import React, { useEffect } from "react";
import { Box } from "@mui/material";
import CustomTab from "../../components/ui/CustomTab";
import { useDispatch } from "react-redux";
import { pushRoute, setSaveDashboardFormState } from "../../store/globalSlice";

const tabs = [
  {
    label: "Define Quota",
    to: "quota",
    value: "/define/quota"
  },
  {
    label: "Quota - Copy & Submit",
    to: "quota-copy-submit",
    value: "/define/quota-copy-submit"
  }, 
];

function Define() {
  const dispatch = useDispatch();
    useEffect(() => {
      dispatch(setSaveDashboardFormState(false));
      dispatch(pushRoute("define"));
    }, []);
	return (
		<Box sx={{ width: "100%", typography: "body1" }}>
         <CustomTab tabs={tabs}/>
		</Box>
	);
}

export default Define;
